export const pl = {
  lang: 'pl',
  data: {
    'ROUTES': {
      'home': 'start',
      'features': 'funkcje',
      'pricing': 'cennik',
      'faq': 'faq',
      'help': 'pomoc',
      'forum': 'forum',
      'blog': 'blog',
      'member': 'strefa-klienta',
      'login': 'logowanie',
      'dashboard': 'pulpit',
      'support': 'wsparcie',
      'tickets': 'zgloszenia',
      'register': 'rejestracja',
      'complete': 'zakonczenie',
      'download': 'pobierz',
      'contact': 'kontakt',
      'profile': 'profil',
      'general': 'ogolne',
      'address': 'adres',
      'company': 'firma',
      'other': 'inne',
      'subscription': 'abonament',
      'manage': 'zarzadzaj',
      'accounts': 'konta',
      'templates': 'szablony',
      'apps': 'aplikacje',
      'legal': 'prawne',
      'terms': 'regulamin',
      'privacy': 'prywatnosc',
      'imprint': 'nota-prawna',
      'cancellation': 'wypowiedzenie',
      'error': 'blad',
      'item-management': 'zarzadzanie-produktami',
      'import-export': 'import-eksport',
      'synchronization': 'synchronizacja',
      'orders': 'zamowienia',
      'messages': 'wiadomosci',
      'marketing': 'marketing',
      'extra': 'dodatki',
      'ai': 'ai',
      'ebay-lister': 'ebay-lister',
      'gpsr': 'gpsr',
      'car-parts': 'czesci-samochodowe',
    },
    'LEGAL': {
      'META': {
        'TERMS': {
          'TITLE': 'Regulamin - dewabit',
          'DESCRIPTION': 'Regulamin korzystania z dewabit, oprogramowania do wystawiania ofert dla sprzedawców eBay.',
        },
        'PRIVACY': {
          'TITLE': 'Polityka prywatności - dewabit',
          'DESCRIPTION': 'Jak dewabit przetwarza i chroni dane osobowe - nasza polityka prywatności w skrócie.',
        },
        'IMPRINT': {
          'TITLE': 'Nota prawna - dewabit',
          'DESCRIPTION': 'Nota prawna i oznaczenie dostawcy BWS IT GmbH, wydawcy dewabit.',
        },
        'CANCELLATION': {
          'TITLE': 'Wypowiedz umowy tutaj - dewabit',
          'DESCRIPTION': 'Wypowiedz subskrypcję dewabit online - bez logowania, z natychmiastowym potwierdzeniem wpływu.',
        },
      },
    },
    'NAV-LINKS': {
      'HOME': 'Start',
      'FEATURES': 'Funkcje',
      'EBAY-LISTER': 'eBay Lister',
      'GPSR': 'GPSR',
      'CARPARTS': 'Części samochodowe',
      'DOWNLOAD': 'Pobierz',
      'PRICING': 'Cennik',
      'FAQ': 'FAQ',
      'HELP-PAGES': 'Strony pomocy',
      'FORUMS': 'Forum',
      'BLOG': 'Blog',
      'CONTACT': 'Kontakt',
      'LOGIN': 'Zaloguj się',
      'REGISTER': 'Zarejestruj się',
      'MEMBER': 'Strefa klienta',
      'MEMBER-DASHBOARD': 'Pulpit',
      'MEMBER-PROFILE': 'Profil',
      'MEMBER-SUBSCRIPTION': 'Twój plan',
      'MEMBER-EBAY-ACCOUNTS': 'Konta ebay',
      'MEMBER-TEMPLATES': 'Szablony',
      'MEMBER-APPS': 'Aplikacje',
      'MEMBER-SUPPORT': 'Wsparcie',
      'IMPRINT': 'Nota prawna',
      'CANCELLATION': 'Wypowiedz umowy tutaj',
      'PRIVACY': 'Prywatność',
      'TERMS': 'Regulamin',
      'LOGOUT': 'Wyloguj',
      'ACCOUNT-MENU': 'Menu konta',
    },
    'GLOBAL': {
      'ERROR': 'Błąd',
      'ERROR-GENERAL': 'Coś poszło nie tak. Spróbuj ponownie później lub skontaktuj się z naszym wsparciem.',
      'SESSION-EXPIRED': 'Twoja sesja wygasła, zaloguj się ponownie',
      'CANCEL': 'Anuluj',
      'TRY-AGAIN': 'Spróbuj ponownie',
      'PLEASE-WAIT': 'Proszę czekać',
      'ARE-YOU-SURE': 'Czy na pewno?',
      'SUCCESS': 'Sukces',
      'DELETE': 'Usuń',
      'WARNING': 'Ostrzeżenie',
      'INFO': 'Info',
      'CHARS-LEFT': 'pozostało znaków',
      'CLOSE': 'Zamknij',
      'CLOSE-WINDOW': 'Zamknij okno',
      'COPY-TO-CLIPBOARD': 'Kopiuj do schowka',
      'YES': 'Tak',
      'NO': 'Nie',
      'CONFIRM': 'Potwierdź',
      'SELECT': 'Wybierz',
      'ACTIVE': 'Aktywny',
      'INACTIVE': 'Nieaktywny',
      'DEFAULT': 'Domyślny',
      'SAVE-CHANGES': 'Zapisz zmiany',
      'FOOTER': {
        'IMPRINT': 'Nota prawna',
        'PRIVACY': 'Prywatność',
        'TERMS': 'Regulamin',
      },
      'UPDATE-AVAILABLE': {
        'HEAD': 'Dostępna aktualizacja!',
        'BODY': 'Dostępna jest nowa wersja. Czy chcesz teraz odświeżyć stronę? Uwaga: ' +
          'niezapisane zmiany zostaną utracone.',
        'LATER': 'Później',
        'RELOAD': 'Odśwież stronę',
      },
      'WEBSOCKET': {
        'TICKET-REPLY': 'Otrzymali Państwo odpowiedź na swoje zgłoszenie do wsparcia.'
      },
      'PAYMENT': {
        'SUBTOTAL': 'Suma częściowa bez VAT',
        'VAT': '{{VATPERCENT}}% VAT od',
        'TOTAL': 'Razem',
        'AMOUNT-TO-PAY': 'Kwota do zapłaty',
        'CB-TERMS': 'Zapoznałem się z regulaminem i akceptuję go',
        'OPEN-NEW-WINDOW': 'Otwórz w nowym oknie',
        'CB-CANCELLATION': 'Żądam i zgadzam się, aby rozpoczęto realizację zamówionej usługi przed upływem terminu odstąpienia od umowy. ' +
          'Wiem, że moje prawo do odstąpienia wygasa z chwilą pełnego wykonania umowy.',
        'CONTINUE-PAYPAL': 'Przejdź do PayPal',
      },
      'LOGIN-MODAL': {
        'HEAD': 'Wprowadź swoje dane dostępowe dewabit, aby się zalogować:',
        'E-MAIL': 'E-mail',
        'E-MAIL-PLACEHOLDER': 'Wprowadź adres e-mail',
        'PASSWORD': 'Hasło',
        'PASSWORD-PLACEHOLDER': 'Wprowadź hasło',
        'LOGIN': 'Zaloguj się',
        'LOGIN-SUCCESS': 'Logowanie udane',
      },
      'COMMUNITY-PUSH': {
        'NEW-POST': 'Nowy post od {{user}}',
        'NEW-THREAD': 'Nowy wątek od {{user}}: {{threadName}}',
      },
      'LOGOUT-SUCCESS': 'Wylogowano pomyślnie',
      'CTA-REGISTER': {
        'CTA-HEAD': 'Załóż teraz bezpłatne konto!',
        'CTA-BODY': 'Rejestracja i testowanie bez ryzyka, bez podawania danych płatniczych',
        'CTA-BTN': 'Zarejestruj się teraz',
      }
    }
  },
};
